import { AuthWellKnownEndpoints, OpenIdConfiguration } from 'angular-auth-oidc-client';

export class OidcUaaConfig {
  baseServiceUrl: string;
  openIDConfiguration: OpenIdConfiguration;
  shouldInitializeConfig?: boolean;
  authWellKnownEndpoints: AuthWellKnownEndpoints;
}
